import React from "react";


function PrivacyHeader() {

    return (
        <>
            <div className="pd-header">

                <div className="header-bottom">
                    <h2 className="pd-title">Privacy</h2>
                </div>
            </div>
        </>
    );
}

export default PrivacyHeader;
